import { useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { PageHeader } from "@ryde/layout";
import { useReportMenuItems } from "@ryde/redux";
import {
  filterAndTranslateReportMenuItemsData,
  reportStartPageSearchAtom,
} from "@ryde/shared";

import {
  ReportStartPageContainerStyled,
  ReportStartPageGroup,
  ReportStartPageSearch,
} from "./start-page";

export const ReportsPageStartContent: FC = () => {
  const menuSearchText = useRecoilValue(reportStartPageSearchAtom);
  const { t } = useTranslation();
  const { reportMenuItems } = useReportMenuItems();

  const menuItemsDataFiltered = useMemo(() => {
    if (!reportMenuItems?.length) {
      return [];
    }

    return filterAndTranslateReportMenuItemsData({
      itemsRaw: reportMenuItems,
      searchText: menuSearchText,
      t,
    });
  }, [menuSearchText, reportMenuItems, t]);
  return (
    <>
      <PageHeader mainTitle={t("general.REPORTS")} hideSecondLine={true} />
      <ReportStartPageContainerStyled>
        {/* The header search is the global ride-ID search, so reports need their own on desktop too */}
        <ReportStartPageSearch />

        {menuItemsDataFiltered?.map(item => (
          <ReportStartPageGroup key={item.id} {...item}></ReportStartPageGroup>
        ))}
      </ReportStartPageContainerStyled>
    </>
  );
};
